


const dayAbbreviation = moment.weekdaysShort();
const dayList = moment.weekdaysShort();
for (let i = 0; i < dayList.length; i++) {
  dayList[i] = dayList[i].replace('.', '');
}
for (let i = 0; i < dayAbbreviation.length; i++) {
  dayAbbreviation[i] = dayAbbreviation[i].charAt(0).toUpperCase().replace('.', '');
}
const monthList = moment.months();
const monthLongList = moment.months();
const dateFormat = {
  formatDisplay (date) {
    return `${dayList[date.getDay()]}, ${monthList[date.getMonth()]} ${date.getDate()}`
  },
  formatMonth (date) {
    return `${monthLongList[date.getMonth()]} ${date.getFullYear()}`
  },
  getWeekDayArray (firstDayOfWeek) {
    let beforeArray = [];
    let afterArray = [];
    for (let i = 0; i < dayAbbreviation.length; i++) {
      if (i < firstDayOfWeek) {
        afterArray.push(dayAbbreviation[i])
      } else {
        beforeArray.push(dayAbbreviation[i])
      }
    }
    return beforeArray.concat(afterArray)
  }
}

export default dateFormat;



// WEBPACK FOOTER //
// ./src/helpers/DatePickerManager/index.js